import { useEffect, useState } from "react";

declare global {
  interface Window {
    onYouTubeIframeAPIReady: () => void;
  }
}

const useYoutubePlayer = (iframeId: string): YT.Player | undefined => {
  const [player, setPlayer] = useState<YT.Player>();

  useEffect(() => {
    const onYouTubeIframeAPIReady = () => setPlayer(new YT.Player(iframeId));

    if (window.YT) {
      onYouTubeIframeAPIReady();
      return;
    }

    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";

    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
  }, [iframeId]);

  return player;
};

export default useYoutubePlayer;
